import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All CATEGORIES SERVICE
export const getCategoriesService = createAsyncThunk(
  "general/getCategoriesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.categoriesURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  All PRODUCTS SERVICE
export const getAllProductsService = createAsyncThunk(
  "general/getAllProductsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.productsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET PRODUCT INFO SERVICE
export const getProductInfoService = createAsyncThunk(
  "general/getProductInfoService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.productsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET => GET FAVORITES
export const getFavoraitesListService = createAsyncThunk(
  "general/getFavoraitesListService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.favoritesURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// ADD => ADD TO FAVORITES
export const addToFavoritesService = createAsyncThunk(
  "general/addToFavoritesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.favoritesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// ADD => ADD RATE
export const addRateService = createAsyncThunk(
  "general/addRateService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(URLS.productRatesURL, null, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET => GET PRODUCT RATE SERVICE
export const getProductRateService = createAsyncThunk(
  "general/getProductRateService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(
        `${URLS.productsURL}/${params?.id}/rates`,
        {
          params: { ...params },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET => GET MY CART SERVICE
export const getMyCartService = createAsyncThunk(
  "general/getMyCartService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.cartURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
// DELETE =>  DELETE CART SERVICE
export const deleteCartService = createAsyncThunk(
  "general/deleteCartService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.cartURL}/delete?cart_id=${params?.cart_id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST => ADD TO CART SERVICE
export const addToCartService = createAsyncThunk(
  "general/addToCartService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(URLS.cartURL, params);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST => ADD TO CART SERVICE
export const addToCartVisitorService = createAsyncThunk(
  "general/addToCartVisitorService",
  async (params, thunkAPI) => {
    alert("dsasdsadas");
    try {
      const response = await axios.post(URLS.cartURL, params, {
        headers: {
          X_VISITOR_ID: params?.x_visitor_id,
          
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE CART SERVICE
export const updateCartService = createAsyncThunk(
  "general/updateCartService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.cartURL}/${params?.id}`,
        params?.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST => TOGGLE FAV SERVICE
export const toggleFavService = createAsyncThunk(
  "general/toggleFavService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.toggleFavURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

//GET => GET STORE INFO
export const getStoreInfoService = createAsyncThunk(
  "general/getStoreInfoService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.storeInfoURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  All Countries SERVICE
export const getCountriesService = createAsyncThunk(
  "general/getCountriesService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.countriesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  All PROVINCIES SERVICE
export const getProvincesService = createAsyncThunk(
  "general/getProvincesService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.countriesURL}/${id}/provinces`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// PLACE ORDER SERVICE

export const placeOrderService = createAsyncThunk(
  "general/placeOrderService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.ordersURL, data);
      console.log(response);
      return response;
    } catch (e) {
      console.log(e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);
// GET ORDER SERVICE
export const getOrderService = createAsyncThunk(
  "general/getOrderService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.ordersURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      console.log(e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);
// CANCEL =>  CANCEL ORDER SERVICE
export const cancelOrderService = createAsyncThunk(
  "general/cancelOrderService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.ordersURL}/${data?.id}/change-status`,
        data
        /* {
          params: { ...params },
        }*/
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// Put =>  UPDATE PROFILE SERVICE
export const updateProfileService = createAsyncThunk(
  "general/updateProfileService",
  async (data, thunkAPI) => {
    console.log(data);
    try {
      const response = await axios.put(URLS.profileURL, data);
      console.log(response);
      return response;
    } catch (e) {
      console.log(e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET => GET ADVERTISMENT SERVICE
export const getAdvertismentService = createAsyncThunk(
  "general/getAdvertismentService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.advertisementsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const checkOrderService = createAsyncThunk(
  "general/checkOrderService",
  async (data, thunkAPI) => {
    console.log(data);
    try {
      const response = await axios.post(URLS.checkURL, data, {
        headers: {
          Accept: "application/json",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
